module.exports = __webpack_public_path__ + "img/staffJounary_headerImg.080d5c15.png";